import * as React from 'react';
import { SubmissionError } from 'redux-form';
import { map, omit, keyBy } from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import {
  campaignCurrentlyEditingAction, campaignsRef, extractCampaignFormData, savedCampaignAction,
  savingCampaignAction
} from "./CampaignOperation";
import { connect } from 'react-redux';
import { CampaignForm } from './campaign-form/CampaignForm';
import { clearSavedCampaignAction } from './CampaignOperation';

const styles = {
  heading: {
    margin: '60px 0',
    textTransform: 'uppercase'
  }
}
export interface CampaignEditProps {
  match: any;
  charities: Array<any>;
  campaigns: any;
  saving: boolean;
  saved: boolean;
  setSaving: () => void;
  setSaved: () => void;
  clearSaved: () => void;
  currentlyEditing: any;
  setCurrentlyEditing: (campaign: any) => void;
  classes: any;
}

class CampaignEditComponent extends React.Component<CampaignEditProps> {
  render() {
    const { charities, saving, saved, classes } = this.props;
    return (
      <div>
        <div className={classes.heading} >
          <Typography variant="display1">Edit Campaign</Typography>
        </div>
        {
          saving === true && <div><i className="fa fa-spinner" aria-hidden="true"/> Saving...</div>
        }
        {
          saved === true &&
          <div className="notification is-primary">
            Saved successfully
          </div>
        }
        <CampaignForm
          charities={charities}
          onSubmit={this.onSubmitHandler}
        />
      </div>
    );
  }

  componentWillMount() {
    const campaignId = this.props.match.params.uid;
    const { campaigns, setCurrentlyEditing, clearSaved } = this.props;
    if (campaigns) {
      const campaign = campaigns[ campaignId ];
      if (campaign) {
        setCurrentlyEditing({
          ...campaign,
          id: campaignId
        });
      }
    }
    clearSaved();
  }

  onSubmitHandler = (values: any) => {
    console.log('dafuq', values);
    const { name, charity, oneOffPayments, monthlyPayments } = values;
    const { setSaving, setSaved, clearSaved, currentlyEditing } = this.props;
    const {logoImgName, logoImgUrl, mobileLogoImgName, mobileLogoImgUrl} = currentlyEditing;

    if (!name) {
      throw new SubmissionError({ name: 'You need to enter a name', _error: 'You need to enter a name!' });
    }

    const charities = omit(values, [ 'id', 'name', 'friendlyId', 'charity', 'charities', 'oneOffPayments', 'monthlyPayments', 'payment' ]);

    map(charities, (val, key) => {
      if (val === true && key !== 'giftAidOption'&& key !== 'includeTarget' && key !== 'skipLandingStep' && key !== 'fundraisingPackConsentIsOptional') {
        delete charities[key];
      }
    });
    
    if(charity) {
      charities[charity] = true;
    }
    const oneOff = keyBy(oneOffPayments, (o) => o.figure);
    const monthly = keyBy(monthlyPayments, (o) => o.figure);

    const payment = {
      monthly,
      oneOff
    }
    const charitiesLength = Object.values(charities).length;
    let hasValidCharities = false;
    map(charities, (val) => {
      if (val === true) {
        hasValidCharities = true;
      }
    });

    if (!charitiesLength || !hasValidCharities) {
      throw new SubmissionError({
        [ charities[ 0 ] ]: 'You need to enter a name',
        _error: 'You need to select a charity!'
      });
    }
    charities.logoImgUrl = logoImgUrl || '';
    charities.logoImgName = logoImgName || '';
    charities.mobileLogoImgUrl = mobileLogoImgUrl || '';
    charities.mobileLogoImgName = mobileLogoImgName || '';

    setSaving();

    // const campaign = extractCampaignFormData({ ...values, charities });
    const newCampaign = {
      name,
      charities,
      payment,
    };

    console.log('saving', newCampaign)

    campaignsRef
      .child(currentlyEditing.id)
      .update(newCampaign)
      .then(() => {
        setSaved();
        setTimeout(() => clearSaved(), 3000);
    });
  }
}

const mapStateToProps = ({ charities, campaigns }) => ({
  charities: charities.all,
  campaigns: campaigns.all,
  currentlyEditing: { ...campaigns.currentlyEditingCampaign, ...campaigns.imageDetails},
  saving: campaigns.saving,
  saved: campaigns.saved,
});

const mapDispatchToProps = (dispatch) => (
  {
    setSaving: () => dispatch(savingCampaignAction()),
    setSaved: () => dispatch(savedCampaignAction()),
    clearSaved: () => dispatch(clearSavedCampaignAction()),
    setCurrentlyEditing: (campaign) => dispatch(campaignCurrentlyEditingAction(campaign))
  });

export const CampaignEdit = withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(CampaignEditComponent));
